import { isApiError } from '@repletoryreach/sdk-api';
import type { Translate } from '../../../i18n/I18nProvider';

/**
 * The words for a refused email change. The service's own message is English
 * only, so each refusal a person can meet here has its own catalogue entry;
 * anything else falls back to what the service said.
 */
export function emailErrorMessage(t: Translate, err: unknown): string {
  if (isApiError(err)) {
    switch (err.code) {
      case 'ADMIN_ROLE_REQUIRED': return t('settings.email.error.adminOnly');
      case 'DOMAIN_TAKEN': return t('settings.email.error.domainTaken');
      case 'DOMAIN_EXISTS': return t('settings.email.error.domainExists');
      case 'NO_PROVIDER': return t('settings.email.error.noProvider');
      case 'NOT_FOUND': return t('settings.email.error.notFound');
      default: break;
    }
  }
  return err instanceof Error ? err.message : t('common.unknownError');
}
